import { getPhoneNumberDigits } from '@/lib/phoneNumber';
export const COMPANY_CLAIM_URL = 'https://admin.viratempo.app';

export function buildCompanyClaimMessage(companyName?: string) {
  return 'Oi! Encontrei vocês no Vira Tempo e vi que os agendamentos online ainda não estão liberados. Vocês pretendem ativar isso em breve?';
}

function normalizeWhatsAppPhoneNumber(phoneNumber?: string) {
  const digitsOnly = getPhoneNumberDigits(phoneNumber);

  if (!digitsOnly) {
    return null;
  }

  if (digitsOnly.startsWith('55')) {
    return digitsOnly;
  }

  return `55${digitsOnly}`;
}

export function buildCompanyClaimWhatsAppUrl(phoneNumber?: string, companyName?: string) {
  const normalizedPhoneNumber = normalizeWhatsAppPhoneNumber(phoneNumber);

  if (!normalizedPhoneNumber) {
    return null;
  }

  return `https://wa.me/${normalizedPhoneNumber}?text=${encodeURIComponent(buildCompanyClaimMessage(companyName))}`;
}
